import { useIns, useStore } from 'src/utils/v2_helper/common';
import { computed } from 'vue';

export const baseService = ['DINE_IN', 'PICK_UP', 'DELIVERY', 'FULL_DINE_IN'];
export function useServiceType() {
  const store = useStore();
  const app = useIns();
  const opened = computed(() => {
    const { service = {}, scheduled = {} } = store.state?.prefetch?.storeInfo || {};
    const list = Object.keys(service).filter(key => service[key]);
    if (scheduled.scheduledEnable && scheduled.scheduledDelivery) list.push('SCHEDULED_DELIVERY');
    if (scheduled.scheduledEnable && scheduled.scheduledPickUp) list.push('SCHEDULED_PICK_UP');
    return list;
  })
  function support(type) {
    if (!app.storeOpened && baseService.includes(type)) return false;
    return opened.value.indexOf(type) >= 0;
  }

  return { support, opened }
}
